import { Component, OnInit } from '@angular/core';
import * as FileSaver from 'file-saver-es';
import { ReportsImportService } from 'src/app/services/reports-import.service';
import { ReportsCommonService } from 'src/app/services/reports-common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { ReplaySubject, map, startWith } from 'rxjs';
@Component({
  selector: 'app-reports-import',
  templateUrl: './reports-import.component.html',
  styleUrls: ['./reports-import.component.scss'],
  standalone: false // NOSONAR
})
export class ReportsImportComponent implements OnInit {

  dropdownOptionimportPlant: any[] = [];
  dropdownOptionimportLP: any[] = [];
  dropdownOptionimportRoute: any[] = [];
  selectedImportPlant: any[] = [];
  selectedImportLP: any[] = [];
  selectedImportRoute: any[] = [];

  list: any;
  errorMessage: any;
  successMessage: any;
  isAccessible = true;
  userContextPayload: any;
  namcFilterCtrl: FormControl = new FormControl();
  filteredNamc: ReplaySubject<any[]> = new ReplaySubject(1);
  lpFilterCtrl: FormControl = new FormControl();
  filteredLp: ReplaySubject<any[]> = new ReplaySubject(1);
  routeFilterCtrl: FormControl = new FormControl();
  filteredRoute: ReplaySubject<any[]> = new ReplaySubject(1);
  constructor(private readonly reportsService: ReportsImportService,
    private readonly commonService: ReportsCommonService,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    public constants: Constants, private readonly aetStateService: AetStateService,
    private readonly router: Router) {
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    const roles = (fgaDetails?.roles ?? []).map((r: any) => r.displayName);
    const fallbackUserPrincipalName = localStorage.getItem('toyotaGUID');
    this.userContextPayload = {
      event: {},
      userReqDto: userInfo,
      isAdmin: !!(fgaDetails?.isAdmin ?? fgaDetails?.user?.isAdmin ?? roles.some((role: string) => role?.toLowerCase().includes('admin'))),
      userId: fgaDetails?.user?.userId ?? fgaDetails?.user?.id ?? fgaDetails?.user?.externalUserId,
      userPrincipalName: fgaDetails?.user?.userPrincipalName ?? fallbackUserPrincipalName,
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName
    };
    this.ngxUiLoaderService?.start(CommonConstant.loader);
    this.commonService.getCommonReportByUser(userInfo).subscribe(data => { // NOSONAR

      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (data) {
        this.list = data

        if (this.list.body.reportPlants && this.list.body.reportPlants.length > 0) {
          this.dropdownOptionimportPlant = this.buildDropdownOptions(
            this.list.body.reportPlants,
            (obj: any) => obj?.itemCode,
            (obj: any) => obj?.itemDesc,
          );
          this.filteredNamc.next(this.dropdownOptionimportPlant?.slice());

          this.selectedImportPlant = this.dropdownOptionimportPlant;
        }
        if (this.list.body.importVendors && this.list.body.importVendors.length > 0) {
          this.dropdownOptionimportLP = this.buildDropdownOptions(
            this.list.body.importVendors,
            (obj: any) => obj?.vendorId,
            (obj: any) => obj?.shortName,
          );
          this.filteredLp.next(this.dropdownOptionimportLP?.slice());

          this.selectedImportLP = this.dropdownOptionimportLP;
        }
        if (this.list.body.routeTypes && this.list.body.routeTypes.length > 0) {
          this.dropdownOptionimportRoute = this.buildDropdownOptions(
            this.list.body.routeTypes,
            (obj: any) => obj?.routeCode,
            (obj: any) => obj?.routeDesc,
          );
          this.filteredRoute.next(this.dropdownOptionimportRoute?.slice());

          this.selectedImportRoute = this.dropdownOptionimportRoute;
        }


      }
    }, _err => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = this.constants.APIErrorMessage;
    })
  }
  ngOnInit(): void {
    
    this.namcFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionimportPlant) : this.dropdownOptionimportPlant?.slice())
      )
      .subscribe(filtered => {
        this.filteredNamc.next(filtered);
      });
    this.lpFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionimportLP) : this.dropdownOptionimportLP?.slice())
      )
      .subscribe(filtered => {
        this.filteredLp.next(filtered);
      });
    this.routeFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionimportRoute) : this.dropdownOptionimportRoute?.slice())
      )
      .subscribe(filtered => {
        this.filteredRoute.next(filtered);
      });
  }
  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return (Array.isArray(list) ? list : []).filter(d =>
      (d?.label ?? '').toString().toLowerCase().includes(filterValue) ||
      (d?.value ?? '').toString().toLowerCase().includes(filterValue)
    );
  }

  private buildDropdownOptions(
    source: any[],
    getLabel: (item: any) => any,
    getValue: (item: any) => any,
  ): Array<{ label: string; value: string }> {
    const mapped = (Array.isArray(source) ? source : [])
      .map((item: any) => ({
        label: (getLabel(item) ?? '').toString().trim(),
        value: (getValue(item) ?? '').toString().trim(),
      }))
      .filter((item: any) => item.value.length > 0);

    const unique = mapped.filter((item, index, arr) =>
      index === arr.findIndex(x => x.label === item.label && x.value === item.value)
    );

    return unique.sort((a, b) => a.value.localeCompare(b.value, undefined, { sensitivity: 'base' }));
  }
  isAllSelected(option: any, list: any): boolean {
    return option?.length == list?.length; // NOSONAR
  }


  isIndeterminate(option: any, list: any): boolean {
    return option?.length > 0 &&
      list?.length > 0 &&
      option?.length < list?.length;
  }


  toggleSelectAll(event: any, list: any[]): any[] {
    return event.checked ? [...list] : [];
  }
  
  download() {
    this.successMessage = null;
    this.errorMessage = null;
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.reportsService.getReportsImport(this.selectedImportPlant, this.selectedImportLP, this.selectedImportRoute, this.userContextPayload)
      .subscribe({
        next: (response) => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          const filename = "AET_Events_Resolutions"
          const data: Blob = new Blob([(<any>response)?.body], { type: 'application/vnd.ms-excel' });
          FileSaver.saveAs(data, filename);
        },
        error: () => {
          this.ngxUiLoaderService.stop(CommonConstant.loader);
          this.errorMessage = this.constants.downloadError;

        }
      })
  }

}
